const URL = "https://ufoodapi.herokuapp.com";

export const login = async (email, password) => {
  const response = await fetch(`${URL}/login`, {
    method: 'POST',
    headers: {'Content-Type': 'application/x-www-form-urlencoded',},
    body: new URLSearchParams({
      'email': email,
      'password': password
    }),
  })
  if (response.status === 200) {
    return response.json();
  } else {
    return ""
  }
}

export const logout = async () => {
  const response = await fetch(`${URL}/logout`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: (
      {}
    ),
  })

  return response.json();
}

export const signup = async (name, email, password) => {
  const response = await fetch(`${URL}/signup`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: new URLSearchParams({
      'name': name,
      'email': email,
      'password': password
    }),
  })

  return response.json();
}

export const getToken = async (token) => {
  const response = await fetch(`${URL}/tokenInfo`, {
    headers: {
      'Authorization': token
    },
  })
  if (response.ok && response.status === 200) {
    const user = await response.json();
    return user
  } else {
    return ""
  }
}
